<template>
  <form id="blogForm" ref="formRef">
    <label class="form-label" for="blog-title">{{ t("TITLE") }}</label>
    <InputText type="text" v-model="blogForm.title" required id="blog-title" class="w-100 mb-2"/>
    <label class="form-label" for="blog-language">{{ t("LANGUAGE") }}</label>
    <Select
        :options="getAvailableLangs"
        v-model="blogForm.lang"
        id="blog-language"
        option-label="label"
        option-value="value"
        required
        class="w-100"
        :placeholder="t('SELECT')"
    />
  </form>
</template>

<script setup>
import {computed, ref, toRefs} from "vue";
import {useI18n} from "vue-i18n";

defineExpose({submitForm});

const {t, availableLocales} = useI18n();
const props = defineProps(["disabledLangs"]);
const {disabledLangs} = toRefs(props);
const formRef = ref(null);
const emits = defineEmits(["submit-blog"]);
const blogForm = ref({
  title: null,
  slug: null,
  titleHtml: null,
  lang: null,
});

function submitForm() {
  if (formRef.value.reportValidity()) {
    blogForm.value.titleHtml = "<div class=\"title-white\">" + blogForm.value.title + "</div>";
    blogForm.value.slug = getSlug(blogForm.value.title);
    emits("submit-blog", blogForm.value);
  }
}

function getSlug(raw) {
  return raw
      .toLowerCase()
      .normalize("NFD")
      .replaceAll(/[–!*'();:@&=+$,/?#[\]]/g, "")
      .trim()
      .replaceAll(/\s+/g, "-")
      .replaceAll(/--+/g, "-");
}

const getAvailableLangs = computed(() => {
  return availableLocales
      .filter((loc) => !disabledLangs.value?.includes(loc))
      .map((loc) => ({label: loc, value: loc}));
});
</script>
